/**
 * A wrapper around the whole app that ensures certain data is loaded before components begin to mount
 * Avoids flickers and wasted render processing as data loads in
 */
import { ReactNode } from "react";
import { GenericErrorPage, PageLoader } from "@/components";
import {
  useAppProperties,
  useMainTabs,
  useInitializeLocalStorage,
} from "@/hooks";
import { useTranslate } from "@/providers/context";

interface GlobalLoadingWrapperProps {
  children: ReactNode | ReactNode[];
}

export const GlobalLoadingWrapper = ({
  children,
}: GlobalLoadingWrapperProps) => {
  const {
    data: properties,
    files,
    isError: propertiesIsError,
  } = useAppProperties({
    refetchOnMount: "always",
  });
  const { translationsIsLoaded, translationsIsError } = useTranslate();
  useMainTabs({ refetchOnMount: "always" }); // Always load but dont block render
  useInitializeLocalStorage(properties);

  return (
    <>
      {propertiesIsError || translationsIsError ? (
        <GenericErrorPage /> // Outage
      ) : !properties || !files || !translationsIsLoaded ? (
        <PageLoader large /> // Loading
      ) : (
        <>{children}</> // Ready
      )}
    </>
  );
};
